import constate from "constate";
import { useEffect, useState } from "react";
import { ComicEvent, ComicSectionData, fakeNow } from "./ComicType";

// const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);
// function useComic({ sections }: { sections: ComicSectionData[] }) {
//   const scrollRef = React.useRef(
//     sections.map(() => {
//       return null;
//     })
//   );
//   const executeScroll = (index: number) => scrollToRef(scrollRef[index]);
//   return { scrollRef, executeScroll };
// }
// export const [ComicScrollProvider, useComicScrollContext] = constate(useComic);

function useComicSection({ comicSection }: { comicSection: ComicSectionData }) {
  // if (now < new Date(comicSection.content.release_date + " +0").getTime()) {
  //   return { status: "loading" };
  // }
  if (comicSection == null) {
    return null;
  }

  const [isVoteOver, setVoteOver] = useState(false);

  useEffect(() => {
    const voteDeadlineTime = new Date(
      comicSection.content.vote_deadline.replaceAll("-", "/") + " +0"
    ).getTime();
    setVoteOver(fakeNow() > voteDeadlineTime);
  }, [comicSection.content.vote_deadline]);

  return {
    section: comicSection,
    isVoteOver,
  };
}

export const [ComicSectionProvider, useComicSecContext] =
  constate(useComicSection);

function useComics({
  comicEvent,
  sections,
}: {
  comicEvent: ComicEvent;
  sections: ComicSectionData[];
}) {
  return { comicEvent, sections };
}

export const [ComicProvider, useComicContext] = constate(useComics);
